import axios from 'axios';

// Support runtime config (Docker) or build-time config (Vite)
const apiUrl = (window as any).env?.VITE_API_URL || (import.meta as any).env.VITE_API_URL || 'http://localhost:5001';

const api = axios.create({
    baseURL: `${apiUrl.replace(/\/$/, '')}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor pour ajouter le token JWT
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
